<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="单位名称">
                <a-input v-model="queryParam.tenantName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="创建时间">
                <a-range-picker
                  format="YYYY-MM-DD"
                  v-model="timeValue"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div style="margin-bottom: 20px">
        <a-button
          type="primary"
          @click="$refs.vrForm.handleAdd()"
          v-hasPermi="['10b98637049fb72c3493a8f4b983d745c:0:c']"
        >
          新增
        </a-button>
      </div>
         <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"

      >
        <span slot="coverImageUrl" slot-scope="text, record">
          <a-image :src="record.coverImageUrl" style="width: 70px; height: 70px" />
        </span>
        <span slot="cuttingStatus" slot-scope="text, record">
          <span v-if="record.cuttingStatus == 0">未开始</span>
          <span v-if="record.cuttingStatus == 1">进行中</span>
          <span v-if="record.cuttingStatus == 2">已完成</span>
          <span v-if="record.cuttingStatus == 3">失败</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a
            @click="$refs.vrForm.handleUpdate(record, undefined)"
            v-hasPermi="['10b98637049fb72c3493a8f4b983d745d:0:d']"
          >
            设置方案
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <vrForm ref="vrForm"></vrForm>
  </page-header-wrapper>
</template>
<script>
import { fetchList, delObj } from '@/api/VR/tenantPlan/index'
import moment from 'moment'
import vrForm from './moduls/vrForm'
import { tableMixin } from '@/store/table-mixin'
export default {
  components: { vrForm },
  mixins: [tableMixin],
  data() {
    return {
      timeValue: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        tenantName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
      },
      loading: false,
      tableSize: 'small',
      columns: [
        {
          title: '单位名称',
          dataIndex: 'tenantName',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      list: [],
      total: 0,
      selectedRowKeys: [],
    }
  },
  methods: {
    handleQuery() {},
    resetQuery() {
      this.queryParam = {}
      this.timeValue = []
    },
    onChangeTime(val) {
      this.queryParam.startTime = this.timeValue[0] ? moment(this.timeValue[0]).format('YYYY-MM-DD') : ''
      this.queryParam.endTime = this.timeValue[1] ? moment(this.timeValue[1]).format('YYYY-MM-DD') : ''
      console.log(this.queryParam)
    },
    getList() {
      this.loading = true
      fetchList(this.queryParam)
        .then((res) => {
          this.loading = false
          this.list = res.data.records
          this.total = res.data.total
        })
        .catch(() => {
          this.loading = false
        })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
  },
  mounted() {
    this.getList()
  },
}
</script>